
import Logger from 'js-logger';
import TurnGenerator from './TurnGenerator';

const cupScrambles = [
  [2, 4, 1, 6, 3, 0, 5],
  [3, 5, 2, 0, 4, 6, 1],
  [4, 2, 3, 0, 1, 6, 5],
  [0, 3, 2, 6, 4, 5, 1],
  [5, 1, 6, 3, 4, 2, 0],
  [5, 4, 2, 1, 0, 6, 3],
  [0, 3, 1, 2, 6, 4, 5],
  [1, 4, 2, 0, 6, 5, 3],
  [4, 2, 1, 5, 0, 3, 6],
  [1, 5, 3, 4, 6, 0, 2]
];


// TODO - improvements
// - Store 'gameRecord' on the server and let it handle passing that
// - Should have easier way of copying duplicate params like 'score' and 'bonusCup' - one object to hold those that are
// copied?

/////////////////////////////////////////////////////////////////////////
// CONSTRUCTOR //////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
const LogicCore = {

  init(game) {

    this.game = game;

    // setup random seed
    var seed = Date.now();
    if (game.config.debug) {
      Logger.info('using seed: ', seed);
    }
    this.game.rnd.sow([seed]);

    // data
    this.gamesPlayed_id = 0;  // id on 'gamesPlayed' table on the DB
    this.balls = null;        // a complete list of balls used in the game, balls are not removed only added to
    this.ballsLeft = 0;
    this.history = null;

    // cup id's
    this.cups = {};
    this.tags = [
      LogicCore.HOLE_TAG_OUTER_RING,    //10
      LogicCore.HOLE_TAG_LARGE_CENTER,  //20
      LogicCore.HOLE_TAG_CENTER,        //30
      LogicCore.HOLE_TAG_CENTER_UPPER,  //40
      LogicCore.HOLE_TAG_MIDDLE_TOP,    //50
      LogicCore.HOLE_TAG_UPPER_LEFT,
      LogicCore.HOLE_TAG_UPPER_RIGHT,
    ];

    // server
    this.server = game.services.server;

    // turn generator
    this.turnGenerator = Object.create(TurnGenerator);

    // signals
    this.onSignalLogicInitialized = new Phaser.Signal();
    this.onSignalScoreChanged = new Phaser.Signal();
    this.onSignalBallsLeftChanged = new Phaser.Signal();
    this.onSignalBonusEvent = new Phaser.Signal();
    this.onSignalLeadersFetched = new Phaser.Signal();
    this.onSignalInitialsSanitized = new Phaser.Signal();

    // BUG in Signal implementation - only sends memorized signals if at least one listener is already attached
    //this.onSignalGameReady = new Phaser.Signal();
    this.onSignalTurnReady = new Phaser.Signal();
    this.onSignalTurnReady.memorize = true;

    return this;
  },

  reset() {

  },

  update() {

  },

  pause() {

    // in case we need to pause timers or anything else

  },

  startGame: function() {

    // get initial data from server
    this.server.startGame().addOnce((data, error) => {

      const initialGameData = this.turnGenerator.startGame();

      this.history = [initialGameData.newBalls.map(ball => ball.multiplier)];
      this.gamesPlayed_id = data.gamesPlayed_id;

      if (error) {
        // display the error somehow
        this.onSignalGameReady.dispatch([], error);
      }
      else {

        // a bunch of balls
        this.balls = initialGameData.newBalls;
        this.ballsLeft = this.balls.length;
        this.onSignalBallsLeftChanged.dispatch(this.ballsLeft);

        // score is 0
        this.onSignalScoreChanged.dispatch(this.score, 0);

        // setup cup id's for first turn
        this._ids(this.turnGenerator.gameData.ids, this.turnGenerator.gameData.scr);

        this.onSignalTurnReady.dispatch(this.balls);
      }

    });

  },

  recordResult: function(ballAttributes, holeTag) {

    // award points based on hole
    const holePoints = LogicCore.POINTS[holeTag].points;
    const awardLevel = LogicCore.POINTS[holeTag].award;
    const points = holePoints * ballAttributes.multiplier;

    // bonus events
    if (holePoints === 100) {
      this.onSignalBonusEvent.dispatch(LogicCore.BONUS_EVENT_GT_100_POINTS, points);
    }

    if (ballAttributes.multiplier === 2) {
      this.onSignalBonusEvent.dispatch(LogicCore.BONUS_EVENT_2X_MULTIPLIER, points);
    }
    else if (ballAttributes.multiplier === 4) {
      this.onSignalBonusEvent.dispatch(LogicCore.BONUS_EVENT_4X_MULTIPLIER, points);
    }

    // bonus ball
    const id = this.cups[holeTag].id;
    if (id === this.turnGenerator.gameData.bonusCup) {
      this.onSignalBonusEvent.dispatch(LogicCore.BONUS_EVENT_EXTRA_BALL, points);
    }

    this.history.push({
      mult: ballAttributes.multiplier,
      score: this.score,
      cupId: id,
      bonusCup: this.turnGenerator.gameData.bonusCup,
      extraBall: (id === this.bonusCup),
      time: Date.now()}
    );

    // update score, get more balls
    const newTurnData = this.turnGenerator.endTurn(ballAttributes, id, points);

    // update score
    this.onSignalScoreChanged.dispatch(this.score, points);

    // update balls left
    this.ballsLeft--;
    this.onSignalBallsLeftChanged.dispatch(this.ballsLeft);

    // check for end-game
    if (newTurnData.endgame) {

      // clear all balls
      this.ballsLeft = 0;

      this.server.endGame(this.gamesPlayed_id, this.score).addOnce((data, error) => {

        console.log('endGame->response', data);

        if (error) {
          // display the error somehow
          console.log('recordResult error:', error);
        }

        // exception?
        if (data.exc) {
          // send history
          this.server.recordError('end-game', JSON.stringify(this.history), this.gamesPlayed_id);
        }

        this.onSignalTurnReady.dispatch([], error);

      });
    }
    else {

      // set new cup id's
      this._ids(this.turnGenerator.gameData.ids, this.turnGenerator.gameData.scr);

      // check new balls
      if (newTurnData.newBalls && newTurnData.newBalls.length > 0) {

        this.balls = [...this.balls, ...newTurnData.newBalls];
        this.ballsLeft += newTurnData.newBalls.length;
        this.onSignalBallsLeftChanged.dispatch(this.ballsLeft);

        // bonus?
        if (newTurnData.newBalls.length > 1) {
          this.onSignalBonusEvent.dispatch(LogicCore.BONUS_EVENT_BONUS_BALLS);
        }

        this.history.push([newTurnData.newBalls.map(ball => ball.multiplier)]);
      }
    }

    // indicate turn ready, even if game is over
    this.onSignalTurnReady.dispatch(newTurnData.newBalls);


    return {points, holeTag, level: awardLevel, ballAttributes};
  },

  fetchRank: function() {
    return new Promise((resolve, reject) => {
      // fetch rank for the latest score
      this.server.fetchRankData(this.score).addOnce((data, error) => {
        if (error) {
          Logger.error(error);
          reject(error);
        } else {
          resolve(data);
        }
      });
    });
  },

  fetchLeaders: function() {

    // fetch leader data and rank
    this.server.fetchLeaderData(LogicCore.LEADERS_TO_SHOW).addOnce((data, error) => {

      let leaderData = [];
      if (error) {
        Logger.error(error);
      }
      else {
        // change 'player_initials' to 'name'
        leaderData = data.map(({id: gamesPlayed_id, score, player_initials: name}) => {
          return {
            user: (gamesPlayed_id === this.gamesPlayed_id),
            score,
            name
          };
        });

      }

      this.onSignalLeadersFetched.dispatch(leaderData);

    });

    return this.onSignalLeadersFetched;
  },

  submitPlayerInitials: function(initials) {

    this.server.submitPlayerInitials(this.gamesPlayed_id, initials).addOnce((data, error) => {
      if (error) {
        Logger.error(error);
      }
      else {
        this.onSignalInitialsSanitized.dispatch(data.player_initials);
      }

    });
  },

  isGameOver: function() {

    return (this.ballsLeft <= 0);
  },

  getBonusCupTag: function() {

    for (const tag in this.cups) {
      if (this.cups[tag].id === this.turnGenerator.gameData.bonusCup) {
        return tag;
      }
    }
    return null;
  },

  /////////////////////////////////////////////////////////////////////////
  // LISTENERS ////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////


  /////////////////////////////////////////////////////////////////////////
  // HELPERS //////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////
  _ids: function(ids, scr) {

    const cupScramble = cupScrambles[scr];

    // match cup tags to ids
    this.cups = {};
    ids.forEach((id, idx) => {

      let tag = this.tags[cupScramble[idx]];
      this.cups[tag] = {id};
    });
  }
};

Object.defineProperty(LogicCore, 'score', {

  get: function () {

    return this.turnGenerator.gameData.score;
  },

  set: function (value) {


  }

});

// CONSTANTS
LogicCore.HOLE_TAG_CENTER = 'center-cup';
LogicCore.HOLE_TAG_CENTER_UPPER = 'center-upper-cup';
LogicCore.HOLE_TAG_LARGE_CENTER = 'large-center-cup';
LogicCore.HOLE_TAG_MIDDLE_TOP = 'middle-top-cup';
LogicCore.HOLE_TAG_UPPER_LEFT = 'upper-left-cup';
LogicCore.HOLE_TAG_UPPER_RIGHT = 'upper-right-cup';
LogicCore.HOLE_TAG_OUTER_RING = 'outer-ring';

// Try using computed properties or 'Symbols' here:
// LogicCore.POINTS = {
//   [LogicCore.HOLE_TAG_CENTER]: {points: 30, award: 1},
// ...
LogicCore.POINTS = {};
LogicCore.POINTS[LogicCore.HOLE_TAG_CENTER] = {points: 30, award: 1};
LogicCore.POINTS[LogicCore.HOLE_TAG_CENTER_UPPER] = {points: 40, award: 1};
LogicCore.POINTS[LogicCore.HOLE_TAG_LARGE_CENTER] = {points: 20, award: 1};
LogicCore.POINTS[LogicCore.HOLE_TAG_MIDDLE_TOP] = {points: 50, award: 2};
LogicCore.POINTS[LogicCore.HOLE_TAG_UPPER_LEFT] = {points: 100, award: 2};
LogicCore.POINTS[LogicCore.HOLE_TAG_UPPER_RIGHT] = {points: 100, award: 2};
LogicCore.POINTS[LogicCore.HOLE_TAG_OUTER_RING] = {points: 10, award: 0};


LogicCore.BONUS_EVENT_NONE = 0;
LogicCore.BONUS_EVENT_GT_100_POINTS = 1;
LogicCore.BONUS_EVENT_2X_MULTIPLIER = 2;
LogicCore.BONUS_EVENT_4X_MULTIPLIER = 3;
LogicCore.BONUS_EVENT_EXTRA_BALL = 4;
LogicCore.BONUS_EVENT_BONUS_BALLS = 5;    // when you win 3 extra balls

LogicCore.LEADERS_TO_SHOW = 10;

export default LogicCore;







// WEBPACK FOOTER //
// ./app/src/logic/LogicCore.js